import Imatge from 'components/3catinfo/Imatge';
import styles from './moduldescarregaapp.module.scss';
import Enllac from 'components/3catinfo/Enllac';

const ModulDescarregaApp = (props) => {
    const {
        titol,
        text,
        linkAppStore = 'https://3catinfo.social/appIOS',
        linkGooglePlay = 'https://3catinfo.social/appAndroid'
    } = props;

    return (
        <div className={styles.modulDescarregaApp} data-testid='descarrega-app'>
            <div className={styles.wrapper}>
                <div className={styles.content}>
                    <h2 className={styles.titol} data-testid='descarrega-app-titol'>
                        {titol}
                    </h2>
                    <p className={styles.text} data-testid='descarrega-app-text'>
                        {text}
                    </p>
                    <Enllac href={linkAppStore} dataTestId='descarrega-app-boto' className={styles.boto}>
                        <Imatge
                            src='/_resources/imatges/3catinfo/downloadappstore.svg'
                            width='90'
                            height='24'
                            alt="Descarrega't l'aplicació per iOs a l'AppStore"
                        />
                    </Enllac>
                    <Enllac href={linkGooglePlay} className={styles.boto}>
                        <Imatge
                            src='/_resources/imatges/3catinfo/getingoogleplay.svg'
                            width='90'
                            height='24'
                            alt="Descarrega't l'aplicació per Android a Google Play"
                        />
                    </Enllac>
                </div>
            </div>
        </div>
    );
};

export default ModulDescarregaApp;
